export default {
    "app_name": "Brands",
    "guardar": "GUARDAR",
    "cancelar": "CANCELAR",
    "registros_no_encontrados": "No se encontraron registros",
    "server_error": "Ocurrió un error en el servidor. Por favor, intenta más tarde."
};